import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { PropertyStyle } from '__generated__/api';

export const getPropertyStyleInput = (searchCriteria: SearchCriteriaModel): PropertyStyle[] | null => {
  if (searchCriteria.propertyStyle && searchCriteria.propertyStyle.length > 0) {
    return searchCriteria.propertyStyle
      .map(style => {
        const result = PropertyStyle[PropertyStyle[style]];

        return result ? result : null;
      })
      .filter(style => style != null);
  }

  return null;
};
